import { useEffect, useState } from 'react';
import { sprekersApi } from '../api';

/** Haalt een geauthenticeerde media-blob-URL op voor gebruik als <img>/
 * <video>/<audio> src. Geëxtraheerd uit SlideRenderer.tsx zodat
 * CanvasFrameElement.tsx (canvas-frame media, sectie 17) 'm ook kan
 * hergebruiken -- puur een verplaatsing, geen gedragswijziging. */
export function useMediaBlob(mediaId: string | null | undefined) {
  const [url, setUrl] = useState<string | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(false);
    if (!mediaId) {
      setUrl(null);
      return undefined;
    }
    let active = true;
    let objectUrl: string | null = null;
    sprekersApi.getMediaBlobUrl(mediaId).then((blobUrl) => {
      if (!active) {
        window.URL.revokeObjectURL(blobUrl);
        return;
      }
      objectUrl = blobUrl;
      setUrl(blobUrl);
    }).catch(() => {
      if (active) {
        setUrl(null);
        setFailed(true);
      }
    });
    return () => {
      active = false;
      if (objectUrl) window.URL.revokeObjectURL(objectUrl);
    };
  }, [mediaId]);

  return { url, failed };
}

export default function useMediaBlobUrl(mediaId: string | null | undefined) {
  return useMediaBlob(mediaId).url;
}
